export const disabledImgWithBtns = () => {
  var a = document.getElementsByClassName("ImageWithButton");
  for (var i = 0; i < a.length; i++) {
    a[i].style.pointerEvents = "none";
    a[i].style.opacity = "0.5";
  }
  
  
};
export const disablePreviousButton =()=>{
  var b = document.getElementsByClassName("btn btn-chat btn-check");
  for (var i = 0; i < b.length; i++) {
    b[i].style.pointerEvents = "none";
    b[i].style.opacity = "0.5";
    b[i].disabled= true;
  }
}